(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BlockedTimeReasonDialogController', BlockedTimeReasonDialogController);

    BlockedTimeReasonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BlockedTimeReason', 'Facility'];

    function BlockedTimeReasonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BlockedTimeReason, Facility) {
        var vm = this;

        vm.blockedTimeReason = entity;
        vm.clear = clear;
        vm.save = save;
        vm.facilities = Facility.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.blockedTimeReason.id !== null) {
                BlockedTimeReason.update(vm.blockedTimeReason, onSaveSuccess, onSaveError);
            } else {
                BlockedTimeReason.save(vm.blockedTimeReason, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:blockedTimeReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
